import PropTypes from 'prop-types';
import React from 'react';

const CircleButton = ({ className, ariaLabel }) => (
  <button
    type="button"
    className={`tw-btn-rounded ${className}`}
    aria-label={ariaLabel}
  />
);

CircleButton.propTypes = {
  className: PropTypes.string.isRequired,
  ariaLabel: PropTypes.string.isRequired,
};

export default CircleButton;
